import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=1727a01a"
import script from "./project-card.vue?vue&type=script&lang=js"
export * from "./project-card.vue?vue&type=script&lang=js"
import style0 from "./project-card.vue?vue&type=style&index=0&id=1727a01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports